import { useQuery } from "@tanstack/react-query";
import { getAuditLogs } from "api/company.api";
import { QUERY_KEYS } from "config/queryKeys";

export const useGetAuditLogs = (params = {}) => {
  const { page = 1, limit = 10 } = params;

  return useQuery({
    queryKey: QUERY_KEYS.auditLogs.list(page, limit),
    queryFn: () => getAuditLogs({ page, limit }),
    select: (data) => ({
      auditLogs: data?.data?.auditLogs || data?.auditLogs || [],
      pagination: data?.data?.pagination || data?.pagination || {},
    }),
    staleTime: 1000 * 60 * 30,
  });
};
